import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { zh } from './zh.js'
import { en } from './en.js'
import ElementLocale from 'element-ui/lib/locale'
import errorCodeLang from './errorCodeLang.js'
import Cookie from 'js-cookie'
Vue.use(VueI18n)
// console.info(1111, errorCodeLang)
let locale = Cookie.get('userLanguage') === 'ru' ? 'en' : Cookie.get('userLanguage') || navigator.language.toLocaleLowerCase() || navigator.userLanguage || 'en'
const i18n = new VueI18n({
  locale, // 默认语言
  messages: {
    // 引用语言包
    zh: {
      ...zhLocale,
      ...zh,
      ...errorCodeLang.zh
    },
    en: {
      ...enLocale,
      ...en,
      ...errorCodeLang.en
    }
  },
  silentTranslationWarn: true
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
window.i18n = i18n
export default i18n
